import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankReportService {

  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  getMonetaryOrSavingReport(date: number, type: string, isMonetary: boolean) {
    return this.http.get(this.url + "api/erp/bank/reports/balance/" + type, {
      params: {
        type: isMonetary ? 1 : 2,
        date: date
      }
    });
  }

  getMovesReport(account: number, startDate:number, endDate:number, type: string) {
    return this.http.get(this.url + "api/erp/bank/reports/moves/" + type, {
      params: {
        account: account,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getAdvanceReport(transfer: string, endDate:number, type: string) {
    return this.http.get(this.url + "api/erp/bank/reports/advances/"+transfer+'/'+type+'?date='+endDate);
  }
}
